<template>
  <div class="profile-button" v-on:click="profileMenuToggle">

    <v-avatar color="white" size="50">
      <img v-if="user.imageProfileUrl"
           :srcset="user.imageProfileUrl + '=c-w320, ' + user.imageProfileUrl + '=c-w480 1.5x, '+ user.imageProfileUrl + '=c-w640 2x'"
           :src="user.imageProfileUrl + '=c-w640'"
           :alt="user.nameFirstEN">
      <span v-if="!user.imageProfileUrl && user.nameFirstEN">{{user.nameFirstEN.substring(0, 1)}}</span>
    </v-avatar>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'Profile',
  computed: mapState({
    user: state => state.user.userData,
  }),
  created() {
    this.getUser()
  },
  methods: {
    getUser: function () {
      this.$store.dispatch('user/get')
    },
    profileMenuToggle: function () {
      this.$store.dispatch('drawer/toggleProfileMenu')
    }
  }
}
</script>

<style scoped lang="scss">
.profile-button {
  background: #c9242b;
  position: fixed;
  z-index: 11;
  bottom: 0;
  left: 0;
  width: 94px;
  height: 94px;
  border-top-right-radius: 50%;
  cursor: pointer;

  img {
    border: 2px solid #FFFFFF;
  }

  .v-avatar {
    position: absolute;
    top: 22px;
    left: 22px;
  }
}
</style>
